import { getState, getStatePure, modifyState, unsetState } from '~src/state';
import { onErrorShowMessage } from '~src/errors';

export const onEffectSlideInFromLeft = (event) => {
  event.preventDefault();

  const activeObject = window.canvas.getActiveObject();

  if (!activeObject) {
    onErrorShowMessage("Seleziona l'oggetto che vuoi animare");
  }

  const objectsOriginalValues = [];
  const objectIds = [];
  if (activeObject.type === 'activeSelection') {
    // for (const obj of activeObject.getObjects()) {
    //   objectsOriginalValues.push(obj.get('left'));
    //   obj.set({ opacity: 0 });
    //   objectIds.push(obj.giotto.objRefId);
    // }
  } else {
    objectsOriginalValues.push(activeObject.get('left'));
    activeObject.set({
      left: -(
        activeObject.get('width') * activeObject.get('scaleX') +
        activeObject.get('left')
      ),
    });
    objectIds.push(activeObject.giotto.objRefId);
  }

  const pendingAnimation = {
    objects: objectIds,
    fromProps: {
      left: -(
        activeObject.get('width') * activeObject.get('scaleX') +
        objectsOriginalValues[0]
      ),
    },
    toProps: {
      left: objectsOriginalValues[0],
      duration: 1,
      ease: 'Power4.easeOut',
    },
    title: 'Entra da sinistra',
  };

  modifyState('pendingAnimation', pendingAnimation);

  const pages = getStatePure('pages');
  const currentPageIndex = getState('currentPageIndex');
  if (!pages[currentPageIndex].animations) {
    pages[currentPageIndex].animations = [];
  }
  pages[currentPageIndex].animations.push(pendingAnimation);
  modifyState('pages', pages);
  unsetState('pendingAnimation');
  if (activeObject.type === 'activeSelection') {
    // let i = 0;
    // for (const obj of activeObject.getObjects()) {
    //   obj.set({ opacity: objectsOriginalValues[i++] });
    // }
  } else {
    activeObject.set({ left: objectsOriginalValues[0] });
  }

  activeObject.giotto.animationParent.set({
    opacity: 1,
  });
  window.canvas.remove(activeObject);
  window.canvas.renderAll();
};
